const bannerHomeSlider = new Swiper(".home-banner-slider .swiper-container", {
	pagination: {
		el: ".home-banner-slider .swiper-pagination",
		clickable: true,
	},
});

const stepSlider = new Swiper(".step-slider .swiper-container", {
	slidesPerView: 1,
	spaceBetween: 16,
	navigation: {
		prevEl: ".step-slider .swiper-prev",
		nextEl: ".step-slider .swiper-next",
	},
});

const serviceSlider = new Swiper(".service-slider .swiper-container", {
	slidesPerView: 3,
	spaceBetween: 56,
	navigation: {
		prevEl: ".service-slider .swiper-prev",
		nextEl: ".service-slider .swiper-next",
	},
	breakpoints: {
		1410: {
			slidesPerView: 3,
			spaceBetween: 32,
		},
		1024: {
			slidesPerView: 2.5,
			spaceBetween: 16,
		},
		768: {
			slidesPerView: 1.5,
			spaceBetween: 16,
		},
		576: {
			slidesPerView: 1.5,
			spaceBetween: 16,
		},
	},
});

const about6Slider = new Swiper(".about-6-slider .swiper-container", {
	slidesPerView: 4,
	spaceBetween: 32,
	navigation: {
		prevEl: ".about-6-slider .swiper-prev",
		nextEl: ".about-6-slider .swiper-next",
	},
	breakpoints: {
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
		576: {
			slidesPerView: 1,
			spaceBetween: 15,
		},
	},
});

const about7Slider = new Swiper(".about-7-slider .swiper-container", {
	slidesPerView: 5,
	spaceBetween: 32,
	navigation: {
		prevEl: ".about-7-slider .swiper-prev",
		nextEl: ".about-7-slider .swiper-next",
	},
	breakpoints: {
		1024: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 15,
		},
		576: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
	},
});

export default function useSlider() {
	return {};
}
